<template>
    <!-- File Upload -->
    <div>
        <h2>Upload PDF Manual</h2>
        <input type="file" accept=".pdf" @change="handleFileUpload" />
    </div>
    <div class="center-container">
        <h1>Manuals & Videos</h1>

        <!-- Safety Manuals -->
        <table style="margin-bottom: 50px">
            <tr>
                <td style="text-align: center; font-size: 3em" colspan="2">
                    Safety Manuals
                </td>
            </tr>
            <tr>
                <td style="text-align: center">
                    <a
                        href="D3 Safety Manual - 2019 Updates.pdf"
                        target="_blank"
                    >
                        <img
                            width="100"
                            height="75"
                            src="/images/English.png"
                        /><br />English<br />2019
                    </a>
                </td>
                <td style="text-align: center">
                    <a
                        href="D3 Safety Manual Spanish - 2016.pdf"
                        target="_blank"
                    >
                        <img
                            width="100"
                            height="75"
                            src="/images/Spanish.png"
                        /><br />Spanish<br />2016
                    </a>
                </td>
            </tr>
        </table>

        <!-- Videos -->
        <table border="1" bgcolor="#ffffff">
            <tr>
                <td
                    style="
                        width: 800px;
                        font-size: 20px;
                        font-weight: bold;
                        padding-left: 5px;
                    "
                    colspan="3"
                >
                    Videos
                </td>
            </tr>
            <!-- You can loop through your video data here and generate rows dynamically -->
            <tr v-for="video in videos" :key="video.id">
                <td style="padding-left: 5px">
                    <a :href="video.url" target="_blank">{{ video.title }}</a>
                </td>
                <td style="width: 75px; text-align: center">
                    {{ video.duration }}
                </td>
            </tr>
        </table>

        <br /><br /><br />
    </div>
</template>

<script>
export default {
    data() {
        return {
            videos: [
                {
                    id: 1,
                    title: "Access to Employee Exposure and Medical Records",
                    url: "https://pxtv.wistia.com/medias/fhwhf1phh2",
                    duration: "4:18",
                },
                {
                    id: 2,
                    title: "Access to Employee Exposure and Medical Records (Spanish)",
                    url: "https://pxtv.wistia.com/medias/inutrznmno",
                    duration: "5:01",
                },
                {
                    id: 3,
                    title: "Back Safety",
                    url: "https://pxtv.wistia.com/medias/ng12xi5qna",
                    duration: "18:54",
                },
                {
                    id: 4,
                    title: "Back Safety (Spanish)",
                    url: "https://pxtv.wistia.com/medias/gcfppe7u0u",
                    duration: "21:31",
                },
                {
                    id: 5,
                    title: "Blood and Body Fluids Safety Awareness",
                    url: "https://pxtv.wistia.com/medias/goewy14ogc",
                    duration: "9:03",
                },
                {
                    id: 6,
                    title: "Compressed Gas",
                    url: "https://pxtv.wistia.com/medias/5vytc1o4z6",
                    duration: "15:27",
                },
                // {
                //     id: 7,
                //     title: "COVID-19 Employee Guide to Workplace Safety & Health Related to COVID-19",
                //     url: "https://pxtv.wistia.com/medias/jx6tzvloug",
                //     duration: "10:22",
                // },
                {
                    id: 8,
                    title: "Electrical Safety",
                    url: "https://pxtv.wistia.com/medias/k64suf51al",
                    duration: "16:35",
                },
                {
                    id: 9,
                    title: "Emergency Action Plan",
                    url: "https://pxtv.wistia.com/medias/3m45vxh8rx",
                    duration: "6:04",
                },
                {
                    id: 10,
                    title: "Eyewash and Safety Shower",
                    url: "https://pxtv.wistia.com/medias/9y2rpkrsx3",
                    duration: "6:44",
                },
                {
                    id: 11,
                    title: "Fire Extinguisher",
                    url: "https://pxtv.wistia.com/medias/k0dwupzgp7",
                    duration: "8:06",
                },
                {
                    id: 12,
                    title: "Fire Extinguisher (Spanish)",
                    url: "https://pxtv.wistia.com/medias/0ug3l5gw6u",
                    duration: "8:47",
                },
                {
                    id: 13,
                    title: "First Aid (Basic)",
                    url: "https://pxtv.wistia.com/medias/fc7b17oue8",
                    duration: "16:04",
                },
                {
                    id: 14,
                    title: "First Aid (Basic) (Spanish)",
                    url: "https://pxtv.wistia.com/medias/zwxva2w5hs",
                    duration: "18:39",
                },
                {
                    id: 15,
                    title: "Flammable Liquids for Container Storage",
                    url: "https://pxtv.wistia.com/medias/89vq2p7tst",
                    duration: "13:05",
                },
                {
                    id: 16,
                    title: "Forklift",
                    url: "https://pxtv.wistia.com/medias/d9w4bqrkrd",
                    duration: "14:54",
                },
                {
                    id: 17,
                    title: "Forklift (Spanish)",
                    url: "https://pxtv.wistia.com/medias/95kef7bmjw",
                    duration: "19:32",
                },
                {
                    id: 18,
                    title: "Forklift, Order Picker and PFAS",
                    url: "https://pxtv.wistia.com/medias/mml2ds2omo",
                    duration: "19:08",
                },
                {
                    id: 19,
                    title: "General Industry Ergonomics",
                    url: "https://pxtv.wistia.com/medias/ldwzkm8gtg",
                    duration: "16:13",
                },
                {
                    id: 20,
                    title: "General Safety Orientation",
                    url: "https://pxtv.wistia.com/medias/uq9hzkd0wk",
                    duration: "11:06",
                },
                {
                    id: 21,
                    title: "Hand and Portable Power Tools",
                    url: "https://pxtv.wistia.com/medias/011k2cv80g",
                    duration: "23:34",
                },
                {
                    id: 22,
                    title: "Hazard Communication",
                    url: "https://pxtv.wistia.com/medias/fmc7plq331",
                    duration: "21:51",
                },
                {
                    id: 23,
                    title: "Hazard Communication (Spanish)",
                    url: "https://pxtv.wistia.com/medias/2ot0uskbyh",
                    duration: "24:13",
                },
                {
                    id: 24,
                    title: "Hearing Protection",
                    url: "https://pxtv.wistia.com/medias/asta07grqd",
                    duration: "11:17",
                },
                {
                    id: 25,
                    title: "JHA Job Hazard Analysis",
                    url: "https://pxtv.wistia.com/medias/vr5vj4hlid",
                    duration: "14:29",
                },
                {
                    id: 26,
                    title: "Ladder Safety",
                    url: "https://pxtv.wistia.com/medias/4cna6mekqd",
                    duration: "10:09",
                },
                {
                    id: 27,
                    title: "Ladder Safety (Spanish)",
                    url: "https://pxtv.wistia.com/medias/i1bst6dxfp",
                    duration: "10:32",
                },
                {
                    id: 28,
                    title: "Lasers (Supervisor)",
                    url: "https://pxtv.wistia.com/medias/8a5mreziiy",
                    duration: "18:36",
                },
                {
                    id: 29,
                    title: "Lockout Tagout",
                    url: "https://pxtv.wistia.com/medias/jwrts03mae",
                    duration: "13:08",
                },
                {
                    id: 30,
                    title: "Lockout Tagout (Spanish)",
                    url: "https://pxtv.wistia.com/medias/axld4lhmku",
                    duration: "13:31",
                },
                {
                    id: 31,
                    title: "Machine Guarding",
                    url: "https://pxtv.wistia.com/medias/m6d9m0joo9",
                    duration: "14:25",
                },
                {
                    id: 32,
                    title: "Machine Guarding (Spanish)",
                    url: "https://pxtv.wistia.com/medias/lyk7z4jsnq",
                    duration: "16:20",
                },
                {
                    id: 33,
                    title: "Office Ergonomics",
                    url: "https://pxtv.wistia.com/medias/q6ybdqyohh",
                    duration: "14:28",
                },
                {
                    id: 34,
                    title: "Pallet Jack - Electrical",
                    url: "https://pxtv.wistia.com/medias/vsmze6pc6f",
                    duration: "9:17",
                },
                {
                    id: 35,
                    title: "Pallet Jack - Electrical (Spanish)",
                    url: "https://pxtv.wistia.com/medias/6lbxu8gzcz",
                    duration: "10:39",
                },
                {
                    id: 36,
                    title: "Personal Protective Equipment",
                    url: "https://pxtv.wistia.com/medias/em406iqndf",
                    duration: "16:26",
                },
                {
                    id: 37,
                    title: "Personal Protective Equipment (Spanish)",
                    url: "https://pxtv.wistia.com/medias/95ba0vrb6q",
                    duration: "19:29",
                },
                {
                    id: 38,
                    title: "Safety Committee Members",
                    url: "https://pxtv.wistia.com/medias/fiyi43u96x",
                    duration: "11:27",
                },
                {
                    id: 39,
                    title: "Safety Program Overview (Supervisor)",
                    url: "https://pxtv.wistia.com/medias/v1dbybpqis",
                    duration: "8:01",
                },
                {
                    id: 40,
                    title: "Scissor Lifts",
                    url: "https://pxtv.wistia.com/medias/9cyzr6xzbr",
                    duration: "11:07",
                },
                {
                    id: 41,
                    title: "Scissor Lifts (Spanish)",
                    url: "https://pxtv.wistia.com/medias/6zx2gqx0s2",
                    duration: "10:30",
                },
                {
                    id: 42,
                    title: "Slips, Trips and Falls",
                    url: "https://pxtv.wistia.com/medias/1wf2vgji46",
                    duration: "12:19",
                },
                {
                    id: 43,
                    title: "Slips, Trips and Falls (Spanish)",
                    url: "https://pxtv.wistia.com/medias/j6u7pnykjy",
                    duration: "13:51",
                },
                {
                    id: 44,
                    title: "Walking & Working Surfaces",
                    url: "https://pxtv.wistia.com/medias/vsktweych8",
                    duration: "5:16",
                },
                {
                    id: 45,
                    title: "Welding",
                    url: "https://pxtv.wistia.com/medias/tf0l68entr",
                    duration: "18:16",
                },
                // Add more video data here
            ],
        };
    },
};
</script>

<style>
.center-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
